export function makeNetTerms(netTerms) {
    return netTerms === 0 ? {
        type: 'immediate',
        days: null
    } : {
        type: 'net',
        days: netTerms
    };
}
export function netTermsToDays(netTerms) {
    return netTerms.type === 'immediate' ? 0 : netTerms.days;
}
